import React from 'react'
import classNames from 'classnames'
import {
    WemoloCheckCircleIcon,
    WemoloCrossCircleIcon,
    WemoloInfoIcon,
    WemoloTypography
} from '../../../components/Wemolo'
import { CategoryTone, categoryTone, DETECTION_EXPLORER_TEXT, isFieldUnset } from '../config'
import styles from './CategoryBadge.module.css'

export type CategoryBadgeProps = {
    /** Null/undefined renders the "not categorized" pill rather than nothing. */
    category: string | null | undefined
    className?: string
}

// Tone drives the pill color by category group (see categoryTone): green for correct, red for errors
// that affect the lot's error rate, amber for other errors, grey for uncategorized.
const TONE_CLASS: Record<CategoryTone, string> = {
    correct: styles.toneCorrect,
    warning: styles.toneWarning,
    critical: styles.toneCritical,
    uncategorized: styles.toneUncategorized
}

// Correct → check, uncategorized → info, errors → cross.
const TONE_ICON: Record<CategoryTone, React.FC<{ className?: string }>> = {
    correct: WemoloCheckCircleIcon,
    warning: WemoloCrossCircleIcon,
    critical: WemoloCrossCircleIcon,
    uncategorized: WemoloInfoIcon
}

export const CategoryBadge: React.FC<CategoryBadgeProps> = ({ category, className }) => {
    const tone = categoryTone(category)
    const Icon = TONE_ICON[tone]
    return (
        <span className={classNames(styles.badge, TONE_CLASS[tone], className)}>
            <Icon className={styles.icon} />
            <WemoloTypography variant="label-small" tag="span">
                {!category || isFieldUnset(category) ? DETECTION_EXPLORER_TEXT.uncategorized : category}
            </WemoloTypography>
        </span>
    )
}
